import React from 'react';
import "./ProfitsAnalytics.scss";
import DonoughtChart from '../Charts/DonoughtChart/DonoughtChart';

const ProfitsAnalytics = () => {
  const data = {
    labels: [
      "Kopila Tiwari",
      "Maya Magar",
      "Helen Wallace",
      "Okaley Fowler",
      "Lorelei O'Neil",
    ],
    datasets: [
      {
        data: [23.5, 20.5, 45.5, 20.5, 15],
        backgroundColor: [
          "#C1E6F6",
          "#DCF2FB",
          "#115774",
          "#65C1E8",
          "#092B3A",
        ],
        borderWidth: 6,
      },
    ],
  };
  return (
    <div>
      <DonoughtChart data={data} isHalf={false}/>
    </div>
  )
}

export default ProfitsAnalytics